import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { timezoneDate } from '@/common/utils/DateManager';

const state = {
  orderNo: null,
  storeNo: 0,
  userNo: 0,
  orderManageNo: null,
  name: '',
  phone: '',
  address: '',
  addressDetail: '',
  longitude: 0,
  latitude: 0,
  memo: '',
  bank: '',
  accountNumber: '',
  depositHolder: '',
  orderType: null,
  orderDate: timezoneDate(),
  reservedDate: null,
  inquiry: '',
  remindInquiryLater: false,
  paymentMethod: null,
  totalProductsPrice: 0,
  deliveryFee: 0,
  discountAmount: 0,
  couponDiscountAmount: 0,
  pointUsageAmount: 0,
  balance: 0,
  //detail-data
  cart: [],
  invalidStockList: [],
  //meta-data
  coupon: null,
  storeInfo: {
    store: {
      storeNo: 0,
      userNo: 0,
      storeCategoryNo: 0,
      storeTypeNo: 0,
      locationNo: 0,
      owner: '',
      phone: '',
      nameKr: '',
      nameVn: '',
      address: '',
      addressDetail: '',
      tagVn: '',
      tagKr: '',
      blog: '',
      youtube: '',
      hasOffline: '',
      isActive: '',
      isShow: '',
      isWork: '',
      isDeliverable: false,
      isChattable: false,
      isQueryable: false,
      isSupportDelivery: false,
      isSupportPacking: false,
      isSupportVisit: false,
      isViaCash: false,
      isViaCard: false,
      isViaAutomaticWithdrawal: false,
      isViaOnlinePayment: false,
      isPointAvailable: false,
      introduceKr: '',
      introduceVn: '',
      noticeKr: '',
      noticeVn: '',
      regDate: '',
      updateDate: '',
      supportLanguage: '',
      baseDeliveryFee: 0,
      baseDeliveryFeeLimit: 0,
      increaseDeliveryFeePer: 0,
      additionalDeliveryFee: 0,
      maximumDeliveryFee: 0,
      noDeliveryFeeWhen: 0,
      minimumPriceForDelivery: 0,
      minimumDeliveryDuration: 0,
      maximumDeliveryDuration: 0,
      ifAcceptDelivery: 0,
      exceedMinutes: 0,
      discountWhenPack: 0,
      orderCommissions: 0,
      lastCommissionModifiedDate: 0,
      latitude: 0,
      longitude: 0,
      storeNoticeKr: '',
      storeNoticeVn: ''
    },
    businessStatus: 'OPEN',
    isOutOfRange: false,
    isContainUnavailableProduct: false,
    isBlocked: false
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
